<div class="step-progress">
  @for (step of steps; track $index) {
    <div class="step-wrapper">
      <div class="step-clickable-area" [class.clickable]="isClickable($index)" (click)="onStepClick($index)">
        <div class="step" [class.completed]="isCompleted($index)" [class.current]="isCurrent($index)" [class.upcoming]="isUpcoming($index)">
          <div class="step-number">
            @if (isCompleted($index)) {
              <mat-icon>check</mat-icon>
            } @else {
              {{ $index + 1 }}
            }
          </div>
        </div>
        <span class="step-label" [class.completed]="isCompleted($index)" [class.current]="isCurrent($index)" [class.upcoming]="isUpcoming($index)">{{
          step | translate
        }}</span>
      </div>
      @if ($index < steps.length - 1) {
        <div class="step-connector">
          <div class="step-connector-fill" [class.completed]="isConnectorCompleted($index)" [class.partial]="isConnectorPartial($index)"></div>
        </div>
      }
    </div>
  }
</div>
